// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3NFvV","name":"Header_name__ZWbvA","birthday":"Header_birthday__387d_","skeleton":"Header_skeleton__3My0H"};